<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-13 08:58:03
 * @LastEditTime: 2019-08-13 10:37:50
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :modal="false"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-form
        :model="formData"
        status-icon
        :rules="rules"
        ref="formData"
        :label-width="labelWidth"
        class="demo-ruleForm"
      >
        <el-form-item :label="lableArray.id" prop="id">
          <el-input
            type="number"
            v-model.number="formData.id"
            auto-complete
            :disabled="status === 'edit' ? true : false"
          ></el-input>
        </el-form-item>
        <el-form-item :label="lableArray.hieName" prop="hieName">
          <el-input
            type="text"
            v-model.number="formData.hieName"
            suffix-icon="el-icon-edit"
            auto-complete
          ></el-input>
        </el-form-item>
        <el-form-item :label="lableArray.target" prop="target">
          <el-input
            type="text"
            v-model.number="formData.target"
            suffix-icon="el-icon-edit"
            auto-complete
          ></el-input>
        </el-form-item>
        <el-form-item :label="lableArray.hasChildren">
          <el-radio-group v-model="formData.hasChildren">
            <el-radio
              v-for="(item, mark) in radioArray"
              :label="item.value"
              :key="mark"
              >{{ item.text }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="lableArray.hasChildren">
          <el-select
            v-model="formData.hasChildren"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="(item, mark) in radioArray"
              :key="mark"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">


        <el-button type="primary" @click="handleSubmit('formData')">提 交</el-button>
        <el-button @click="resetForm('formData')">重 置</el-button>
        <el-button @click="handleClose">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import { validatePhone, validateEmail, validatePwd } from "@/util/validate";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "treeForm",
  props: {},
  computed: {
    ...mapGetters([
      "dialogVisible",
      "status",
      "dialogTitle",
      "formData",
      "labelWidth",
      "radioArray",
      "lableArray"
    ])
  },
  data() {
    var validateNumber = (rule, value, callback) => {
      console.log("数字验证:", value);
      if (value !== 0) {
        if (!value) {
          return callback(new Error("请输入内容"));
        }
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error("请输入数字值"));
        } else {
          callback();
        }
      }, 1000);
    };
    var validateText = (rule, value, callback) => {
      console.log("文本验证:", value);
      if (!value) {
        callback(new Error("请输入内容"));
      } else {
        callback();
      }
    };
    return {
      rules: {
        id: [{ validator: validateNumber, trigger: "blur" }],
        hieName: [{ validator: validateText, trigger: "blur" }],
        target: [{ validator: validateText, trigger: "blur" }],
        target: [{ validator: validateText, trigger: "blur" }]
      },
      defaltValue: "",
      childValidateRules: []
    };
  },
  watch: {
    dialogVisible(){
      console.log(777,this.formData)
    }
    //   rowData(val) {
    //   },
    //   compositeData: {
    //     handler: function (val) {
    //     },
    //     deep: true,
    //     immediate: true
    //   },
    //   formData: {
    //     handler: function (val) {
    //       this.$nextTick(() => {
    //         if (this.compositeData && Object.keys(val).includes('lev') && Object.keys(val).includes('priv_f_no')) {
    //           try {
    //             this.compositeData.p_priv_f_no.data.forEach(item => {
    //               if (val.p_priv_f_no === item.value) {
    //                 this.formData.lev = item.lev + 1
    //                 throw  new Error("EndIterative")
    //               }
    //             })
    //           } catch (e) {
    //             if (e.message != "EndIterative") throw  e
    //           }
    //         }
    //       })
    //     },
    //     deep: true,
    //     immediate: true
    //   },
  },
  created() {
    console.log(111, this.radioArray);
  },
  methods: {
    ...mapActions(["closeDialog", "submitForm"]),
    handleClose() {
      this.closeDialog();
    },
    //   showDialog(flag, validateRules, lableArray) {
    //     this.editFlag = flag
    //     this.childValidateRules = validateRules
    //     this.$nextTick(() => {
    //       Object.keys(this.formData).forEach((item, index) => {
    //         if (flag === 'edit') {
    //           this.formData[item] = this.rowData[item]
    //         }
    //         if (flag === 'add') {
    //           this.formData[item] = index === 0 ? 0 : ''
    //         }
    //         if (validateRules[index] === 'number') {
    //           this.rules[item] = [
    //             {validator: this.validateNumber, trigger: 'blur'}
    //           ]
    //         }
    //         if (validateRules[index] === 'text') {
    //           this.rules[item] = [
    //             {validator: this.validateText, trigger: 'blur'}
    //           ]
    //         }
    //         if (validateRules[index] === 'email') {
    //           this.rules[item] = [
    //             {validator: this.validateEmailText, trigger: 'blur'}
    //           ]
    //         }
    //         if (validateRules[index] === 'phone') {
    //           this.rules[item] = [
    //             {validator: this.validateTelphone, trigger: 'blur'}
    //           ]
    //         }
    //         if (validateRules[index] === 'password') {
    //           this.rules[item] = [
    //             {validator: this.validatePassword, trigger: 'blur'}
    //           ]
    //         }
    //       })
    //       this.lableArray = lableArray
    //       this.$refs.formData && this.$refs.formData.clearValidate()
    //       this.dialogVisible = true
    //     })
    //   },
    handleSubmit(formName) {
      this.$nextTick(function() {
        this.$refs.formData.validate(valid => {
          console.log("验证结果：", valid);
          if (valid) {
            // this.$emit('submitEditData', this.formData)
            this.submitForm(this.formData).then(res => {
              console.log("提交表单结果：", res);
              this.$message.closeAll()
              this.$message({
                message: "恭喜你，操作成功",
                type: "success"
              });
            });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      });
    },
    resetForm(formName) {
      if (this.$refs.formData !== undefined) {
        // this.$refs.formData.resetFields()
        // Object.keys(this.formData).forEach((item, index) => {
        //   !this.forbidClearFild.includes(item)&&(this.formData[item] = '')
        // })
        // if (this.editFlag === 'add') {
        //   this.formData[Object.keys(this.formData)[0]] = 0
        // }
      }
    }
  }
};
</script>

<style lang="less" scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

input[type="number"] {
  -moz-appearance: textfield;
}

.el-dialog {
  min-width: 350px !important;
  max-width: 510px !important;
}

.el-dialog {
  border-radius: 5px;
}

.el-dialog__title {
  font-size: 16px;
}

.el-dialog__body {
  padding: 30px 50px 0 20px;
}

.el-dialog__footer {
  padding: 10px 40px 20px 20px;
}

.el-dialog {
  border-radius: 5px;
}

.el-dialog__header {
  padding: 15px 20px 10px;
  background-color: #f1f1f1;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.el-select {
  width: 100%;
}

@media screen and (max-width: 768px) {
  .el-dialog__body {
    padding: 30px 30px 0 20px;
  }
}
</style>
